import { render, staticRenderFns } from "./IcPlus.vue?vue&type=template&id=56f28752&scoped=true"
import script from "./IcPlus.vue?vue&type=script&lang=js"
export * from "./IcPlus.vue?vue&type=script&lang=js"
import style0 from "./IcPlus.vue?vue&type=style&index=0&id=56f28752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f28752",
  null
  
)

export default component.exports